import { configureStore } from "@reduxjs/toolkit";
import type { ThunkDispatch, UnknownAction } from "@reduxjs/toolkit";
import authReducer from "./logic/Auth/authSlice";
import betsReducer from "./logic/Bets/betsSlice";
import sportsReducer from "./logic/Sports/sportsSlice";
import usersReducer from "./logic/Users/usersSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    bets: betsReducer,
    sports: sportsReducer,
    users: usersReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;

// In RTK 2, `typeof store.dispatch` only resolves to the plain
// `Dispatch<UnknownAction>` once the middleware configuration is
// inferred dynamically (which our `(getDefaultMiddleware) => ...`
// form drops) — so the thunk overload silently goes missing at every
// call site and TS rejects `dispatch(myThunk())`. Reconstructing the
// intersection explicitly from `ThunkDispatch` + the store's dispatch
// keeps both signatures intact regardless of how the middleware is
// configured.
export type AppDispatch = ThunkDispatch<RootState, undefined, UnknownAction> &
  typeof store.dispatch;
